// extracted by mini-css-extract-plugin
var _1 = "CopiedToTagMoreItem-modulehover__jKEpX";
export { _1 as "hover" }
